<template>
  <div>
    <a-table
      size="small"
      :columns="columns"
      :data-source="projects"
      :loading="loading"
      :row-key="generateRowKey"
      :scroll="{ y: 380 }"
      :row-selection="{
        selectedRowKeys: currentAssociateNumberAndProjectIdArrayWrapped,
        onChange: onSelectChange,
        type: 'radio'
      }"
    >
      <span slot="role" slot-scope="text, record">
        <div class="flex flex-column gap-2">
          <a-tag v-if="record.is_owner === true" color="#eb8f92">OWNER</a-tag>
          <a-tag v-if="record.associate_role && record.associate_role.name.length > 0" color="#238e75">
            {{ record.associate_role.name.toUpperCase() }}
          </a-tag>
        </div>
      </span>
    </a-table>
  </div>
</template>

<script>
import { Table, Tag, notification } from 'ant-design-vue'
import store from '@/store'

export default {
  components: {
    'a-table': Table,
    'a-tag': Tag
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          title: 'Company #',
          dataIndex: 'id',
          key: 'id',
          sorter: (a, b) => a.id - b.id
        },
        {
          title: 'Company Name',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: 'Associate Number',
          dataIndex: 'associate_number',
          key: 'associate_number'
        },
        {
          title: 'Role',
          key: 'role',
          scopedSlots: { customRender: 'role' }
        }
      ]
    }
  },
  computed: {
    projects() {
      return this.$store.state.applicationState.allProjects.filter(
        project => project.is_active_associate && project.permissions.some(perm => perm.group === 'administrator')
      )
    },
    currentAssociateNumberAndProjectIdArrayWrapped() {
      return [
        this.$store.state.applicationState.currentProject.id +
          '_' +
          this.$store.state.applicationState.associate.associate_number
      ]
    },
    currentProject() {
      return this.$store.state.applicationState.currentProject
    },
    currentAssociate() {
      return this.$store.state.applicationState.associate
    }
  },
  methods: {
    async changeProject(newProjectId) {
      this.loading = true
      await this.$store
        .dispatch('switchProject', { project_id: newProjectId })
        .then(async () => {
          await store.dispatch('loadApplicationState')
        })
        .finally(() => (this.loading = false))
    },

    async onSelectChange(newAssociateNumberAndProjectIdArrayWrapped) {
      this.loading = true
      const oldProjectName = this.currentProject.name
      const oldProjectId = this.currentProject.id
      const oldAssociateNumber = this.currentAssociate.associate_number
      const newAssociateNumber = newAssociateNumberAndProjectIdArrayWrapped[0].split('_')[1]
      const newProjectId = newAssociateNumberAndProjectIdArrayWrapped[0].split('_')[0]

      if (oldAssociateNumber != newAssociateNumber && oldProjectId == newProjectId) {
        try {
          await this.$store.dispatch('switchAssociate', {
            project_id: newProjectId,
            current_associate_number: oldAssociateNumber,
            associate_number_to_switch: newAssociateNumber
          })
        } catch (error) {
          console.error('An error occurred when switching the associate:', error)
        }
      }

      try {
        await this.$store.dispatch('switchProject', {
          project_id: newProjectId
        })

        await this.$store.dispatch('loadApplicationState')
        await this.$router.replace({ name: 'home', query: {} }).catch(() => {})

        notification.success({
          message: 'Success',
          description: 'Company successfully switched from ' + oldProjectName + ' to ' + this.currentProject.name
        })
      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'An error occurred during the process. Please try again later'
        })
      } finally {
        this.loading = false
      }

      window.location.reload()
    },

    generateRowKey(record) {
      return `${record.id}_${record.associate_number}`
    }
  }
}
</script>
